<template>
  <div v-if="!isEmailAI" class="loading">
    <div></div>
    <div></div>
    <div></div>
  </div>
  <div v-else style="display: flex;align-items: center">
    <div v-if="showIcon" style="height: 100%;display: flex;align-items: center;margin-right: 5px;">
      <img style="width:16px;height:16px;" :src="aiIcon"/>
    </div>
    <div style="vertical-align: middle">{{ loadingText }}</div>
    <div style="display: flex;align-items: center;margin-right: -10px" v-if="isSelectModel&&!showIcon">
      <img src="@/assets/AI/sdsk.svg" style="width: 20px;height: 20px;margin-right: 4px">
      <span>{{ $t('ai.deep.seek') }}</span>
    </div>
    <div class="loading">
      <div></div>
      <div></div>
      <div></div>
    </div>
  </div>
</template>

<script setup>
import aiIcon from "@/assets/AI/AI@2x.png"
import {ref, onMounted, onUnmounted, defineProps} from 'vue'
import sessionStore from "@/utils/sessionStore";

const {isEmailAI, isSelectModel} = defineProps({
  isEmailAI: {
    type: Boolean,
    default: false,
  },
  isSelectModel: {
    type: Boolean,
    default: false
  }
})

const loadingTexts = [
  '正在思考你的需求',
  '正在翻阅相关历史邮件',
  '正在整理最终结果'
]

const loadingText = ref(loadingTexts[0])
let timer = null
let index = 0

const STORAGE_KEY = 'email_ai_loading_text_shown'
const showIcon = ref(true)
onMounted(() => {
  const hasShown = sessionStore.get(STORAGE_KEY)
  // ✅ 已经展示过一次：直接停在最后一句
  if (hasShown) {
    index = loadingTexts.length - 1
    loadingText.value = "";
    showIcon.value = false;
    return
  }

  // ❗ 第一次才走你的原逻辑
  timer = setInterval(() => {
    if (index >= loadingTexts.length - 1) {
      clearInterval(timer)
      sessionStore.set(STORAGE_KEY, '1') // 标记已展示
      return
    }

    index++
    loadingText.value = loadingTexts[index]
  }, 2000)
})

onUnmounted(() => {
  clearInterval(timer)
})

</script>

<style lang="less" scoped>
.loading,
.loading > div {
  position: relative;
  box-sizing: border-box;
}

.loading {
  display: block;
  font-size: 0;
  color: #000;
}

.loading.la-dark {
  color: #333;
}

.loading > div {
  display: inline-block;
  float: none;
  background-color: currentColor;
  border: 0 solid currentColor;
}

.loading {
  width: 54px;
  height: 18px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.loading > div {
  width: 5px;
  height: 5px;
  margin: 2px;
  border-radius: 100%;
  opacity: 0;
  animation: ball-fall 1s ease-in-out infinite;
}

.loading > div:nth-child(1) {
  animation-delay: -200ms;
}

.loading > div:nth-child(2) {
  animation-delay: -100ms;
}

.loading > div:nth-child(3) {
  animation-delay: 0ms;
}

@keyframes ball-fall {
  0% {
    opacity: 0;
    transform: translateY(-145%);
  }

  10% {
    opacity: 0.5;
  }

  20% {
    opacity: 1;
    transform: translateY(0);
  }

  80% {
    opacity: 1;
    transform: translateY(0);
  }

  90% {
    opacity: 0.5;
  }

  100% {
    opacity: 0;
    transform: translateY(145%);
  }
}
</style>